import { createStore, applyMiddleware, compose } from "redux";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

import nqbApp from "../reducers/index";
import thunk from "redux-thunk";
const store = createStore(nqbApp, composeEnhancers(applyMiddleware(thunk)));
export default store;



// WEBPACK FOOTER //
// ./application/frontend/src/store/store.js